import { RoomEvent, MatrixEvent, EventType } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { matrixClient } from '../../client';
import { roomData } from '../data';
import { merge } from 'lodash';

const fileLogger = new Log(false, 'im.client.room.handlers.powerLevels');
// fileLogger.childrenPaused = true;

function onPowerLevelsChanged(event: MatrixEvent) {
    const logger = fileLogger.sub(false, 'onPowerLevelsChanged');
    logger.pause = true;
    logger.log('onPowerLevelsChanged', event);
    const roomId = event.getRoomId();
    if (!roomId) return;

    const content = event.getContent();
    logger.log(`Power levels changed in room ${roomId}:`, content);

    // 先判断是否存在原有对象
    if (!roomData.powerLevels[roomId]) {
        // 如果不存在，直接创建新对象
        roomData.powerLevels[roomId] = { ...content };
    } else {
        // 如果存在，使用 merge 更新现有对象
        merge(roomData.powerLevels[roomId], content);
    }
}

export const powerLevelsHandler = {
    init() {
        // 监听房间时间线事件
        matrixClient.clientOnEventDispatcher.addListener(
            RoomEvent.Timeline,
            (event: MatrixEvent, room: any, toStartOfTimeline?: boolean) => {
                const logger = fileLogger.sub(false, 'powerLevelsHandler.init.onTimeline');
                logger.pause = true;
                logger.log('onTimeline', event.getType(), event);
                if (event.getType() === EventType.RoomPowerLevels) {
                    onPowerLevelsChanged(event);
                }
            }
        );

        // 监听用户登出事件
        matrixClient.imDispatcher.addListener('onUserSignout', () => {
            // 清空权限等级数据
            Object.keys(roomData.powerLevels).forEach(roomId => {
                delete roomData.powerLevels[roomId];
            });
        });
    }
}; 